<template>
  <span :class="className">{{ getTranslation(translation) }}</span>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'LocalizedLabel',
  props: {
    className: {
      type: String,
      default: null,
    },
    translation: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['getTranslation']),
  },
});
</script>
